import { useSelector } from 'react-redux';
import { getX50History } from '../selectors';
import { IStore } from 'store/interface';

export const useGameHistory = () => ({
  history: useSelector<IStore, IStore['x50']['history']>(getX50History),
});
